import { normalizeId } from './id';

export type ChapterLike = {
  _id: string;
  order?: number;
  isCompleted?: boolean;
  items?: Array<{ isCompleted?: boolean }>;
};

/** Chapitre terminé (flag backend ou tous les items complétés). */
export const isChapterFullyCompleted = (chapter: ChapterLike): boolean => {
  if (chapter.isCompleted) return true;
  const items = chapter.items ?? [];
  if (items.length === 0) return false;
  return items.every((item) => item.isCompleted);
};

/** Tous les chapitres d'ordre inférieur sont terminés. */
export const arePriorChaptersCompleted = (
  chapters: ChapterLike[],
  chapterId: string
): boolean => {
  const sorted = [...chapters].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  const index = sorted.findIndex((ch) => normalizeId(ch._id) === normalizeId(chapterId));
  if (index <= 0) return true;

  for (let i = 0; i < index; i += 1) {
    if (!isChapterFullyCompleted(sorted[i])) return false;
  }
  return true;
};
